import React, { useEffect, useState, useRef } from 'react';
import { Grid, Stack, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTheme } from '@mui/material/styles';
import EirDeviceCard from './EirDeviceCard';
import styles from './styles';
import ExpandMore from '../shared/ExpandMore.styled';

const EirDeviceCardContainer = ({ devices, sortType, loading, isPrepayHandset }) => {
  const theme = useTheme();
  const [expanded, setExpanded] = useState(false);
  const [deviceList, setDeviceList] = useState(devices);
  const updatedCardsRef = useRef(null);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const sortdeviceList = ({ list, type }) => {
    let sortedArrayList;
    if (type === 'default') {
      sortedArrayList = [...list]
        ?.filter(obj => obj.sortOrder !== null && obj.sortOrder !== 0)
        .sort((a, b) => a.sortOrder - b.sortOrder)
        .concat(list.filter(obj => obj.sortOrder === null || obj.sortOrder === 0));
    } else if (type === 'lth') {
      sortedArrayList = [...list]?.sort((a, b) => a.price - b.price);
    } else {
      sortedArrayList = [...list]?.sort((a, b) => b.price - a.price);
    }
    return sortedArrayList;
  };
  const equipmentListCard = list => {
    const x = sortdeviceList({ list, type: sortType });
    return x.map((device, i) => (
      <EirDeviceCard
        key={i}
        ref={i === 12 ? updatedCardsRef : null}
        device={device}
        loading={loading}
        isPrepayHandset={isPrepayHandset}
      />
    ));
  };

  useEffect(() => {
    setDeviceList(devices);
  }, [devices]);

  useEffect(() => {
    if (expanded && !loading && updatedCardsRef.current) {
      requestAnimationFrame(() => {
        updatedCardsRef.current.focus();
        updatedCardsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }, [expanded, loading]);

  return (
    <Grid
      container
      spacing={{ xs: 2, sm: 3, md: 2 }}
      justifyContent='center'
      sx={{
        marginLeft: { xs: 0 },
        width: {
          xs: '100%',
        },
      }}
    >
      {!expanded && equipmentListCard(sortType === 'default' ? devices : deviceList).slice(0, 12)}
      {!loading && expanded && equipmentListCard(sortType === 'default' ? devices : deviceList)}
      {deviceList.length > 12 && !loading && (
        <Grid item xs={12} sx={styles.showMore}>
          <Stack
            direction='row'
            maxWidth='fit-content'
            alignItems='center'
            onClick={handleExpandClick}
            sx={{ m: '0 auto', cursor: 'pointer' }}
          >
            <Typography variant='h6' sx={styles(theme).showMoreText}>
              {!expanded ? 'Show more devices' : 'Show less devices'}
            </Typography>
            <ExpandMore
              expand={expanded}
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label='show more devices'
            >
              <ExpandMoreIcon sx={{ color: theme.palette.primary.buttonColor }} />
            </ExpandMore>
          </Stack>
        </Grid>
      )}
    </Grid>
  );
};

export default EirDeviceCardContainer;
